export default __webpack_public_path__ + "static/home-image2-344e2f263d7273a1032679a873e574a6.webp";